export default __webpack_public_path__ + "static/media/barefoot-mini-course.2076fa29.png";